export default __webpack_public_path__ + "static/media/google_play.d34e03b1.png";